module.exports = __webpack_public_path__ + "media/images/balance-prosperity-futura-90d55f8c1f5cde27c16c44df54e631b3.png";